import { dashboard } from 'types';
import { toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export const initialState: FacebookLoginState = {
  isInitialized: false,
  redirectUri: null,
};

export interface FacebookLoginState {
  isInitialized: boolean;
  redirectUri: string | null;
}

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_DONE: {
      return {
        ...state,
        isInitialized: true,
        redirectUri: toJSON<dashboard.FacebookAppStoreLoginResponse>(payload).redirectUri,
      };
    }
    case AppConstants.FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}
